import { useEffect } from "react";
import type { TypedWrappedFieldProps } from "redux-form";

import { Box, Typography } from "@braintrust/braintrust-ui-components";
import { DoubleDatePopoverPickerField } from "@js/forms/fields";
import { dateDifference } from "@js/utils";

import { ProjectDurationTileButton } from "./project-duration-tile-button";

type ProjectDurationFieldProps = {
  deadline: TypedWrappedFieldProps<string>;
  contract_type: TypedWrappedFieldProps<string>;
  start_date: TypedWrappedFieldProps<string>;
  isEditForm: boolean;
};

export const ProjectDurationField = ({
  contract_type: contractType,
  deadline,
  start_date,
  isEditForm,
}: ProjectDurationFieldProps) => {
  const setContractType = contractType.input.onChange;
  const contractTypeValue = contractType.input.value;
  const { error: contractTypeError, touched: contractTypeTouched } =
    contractType.meta;
  const { error: deadlineError } = deadline.meta;
  const { error: startDateError } = start_date.meta;

  useEffect(() => {
    const value = deadline.input.value;
    if (value) {
      const isLongTerm = dateDifference(value, undefined, "M") >= 6;
      setContractType(
        isLongTerm ? ENUMS.JobContractType.LONG : ENUMS.JobContractType.SHORT,
      );
    }
  }, [deadline.input.value, setContractType]);

  const error = startDateError || deadlineError;

  return (
    <Box>
      <Box sx={{ mb: 2.25 }}>
        <Typography component="label">
          How long will the Talent work on this job?
        </Typography>
      </Box>
      {contractTypeError && contractTypeTouched && (
        <Typography component="p" variant="paragraph" error sx={{ mb: 2 }}>
          {contractTypeError}
        </Typography>
      )}

      <ProjectDurationTileButton
        value={contractTypeValue}
        onChange={(contract) => setContractType(contract as string)}
      />

      <Box sx={{ mt: 3 }}>
        <DoubleDatePopoverPickerField
          id="start-date-and-deadline"
          startDateField={start_date}
          endDateField={deadline}
          disablePast={!isEditForm}
          hideError
        />

        {!!error && (
          <Typography
            component="p"
            variant="paragraph"
            color="negative"
            className="error-section"
            sx={{ my: 2 }}
          >
            {error}
          </Typography>
        )}
      </Box>
    </Box>
  );
};
